import { render, staticRenderFns } from "./InboxChat.vue?vue&type=template&id=a88992a8&"
import script from "./InboxChat.vue?vue&type=script&lang=js&"
export * from "./InboxChat.vue?vue&type=script&lang=js&"
import style0 from "./InboxChat.vue?vue&type=style&index=0&id=a88992a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports